<template>
  <el-dialog :title="fileCallName + '重命名'" :visible.sync="currentValue" :width="'422px'" :close-on-click-modal="false" custom-class="file-management-dialog" append-to-body>
    <el-input ref="input" :class="{ renameErr }" type="textarea" maxlength="20" v-model="newFolderName" placeholder="请输入名称" :rows="3" @keydown.native="newFolderFnKeydown($event)"></el-input>
    <div class="err" v-if="renameErr">
      <i class="icon iconfont icontishi"></i>
      与现有{{ fileCallName }}重名，请重新输入
    </div>
    <div class="dialog-footer" slot="footer">
      <span class="cancel text-btn-active" @click="currentValue = false" style="margin-right: 24px;">取消</span>
      <wf-button type="primary" @click="newFolderFn">确 定</wf-button>
    </div>
  </el-dialog>
</template>
<script>
import fileApi from "@/services/api/fileManagement";
export default {
  props: ["value", "dataset"],
  computed: {
    currentValue: {
      get: function () {
        this.newFolderName = this.dataset?.type === 1 ? this.dataset?.fileable?.folder_name : this.getFileName(this.dataset?.fileable?.attachment_name);
        this.$nextTick(() => {
          this.$refs?.input?.focus();
        });
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
    fileCallName() {
      return this.dataset.type === 1 ? "文件夹" : "文件";
    },
  },
  data() {
    return {
      renameErr: false, //重命名错误
      newFolderName: "",
      rename: "",
    };
  },
  watch: {
    newFolderName(val) {
      if (this.renameErr) {
        if (val !== this.rename) {
          this.renameErr = false;
        }
      }
    },
  },
  methods: {
    getFileName(val) {
      if (!val) return "";
      const num = val.lastIndexOf(".");
      const idx = num >= 0 ? num : val.length;
      return val.substr(0, idx);
    },
    //输入框回车键
    newFolderFnKeydown(event) {
      if (event.keyCode === 13) {
        this.newFolderFn();
        event.preventDefault(); // 阻止浏览器默认换行操作
        return false;
      }
    },
    async newFolderFn() {
      if (!this.newFolderName) return;

      this.newFolderName = this.newFolderName.trim();

      const _name = this.dataset.type === 1 ? this.newFolderName : this.newFolderName + "." + this.dataset.fileable.attachment_type;

      try {
        const _data = {
          file_tree_id: this.dataset.id,
          rename_file_name: _name,
        };
        const res = await fileApi.renameFile(_data);
        if (res) {
          this.dialogVisible = false;
          this.$message({
            message: "重命名成功",
            type: "success",
          });
          this.$emit("updateInit");
        }
      } catch (err) {
        if (err.message.indexOf("重名") >= 0) {
          this.rename = this.newFolderName;
          this.renameErr = true;
        } else {
          this.$message.error(err.message);
        }
      }
    },
  },
};
</script>
